import { render, staticRenderFns } from "./Lgx243816597420835671.vue?vue&type=template&id=bbefff08&scoped=true&"
import script from "./Lgx243816597420835671.vue?vue&type=script&lang=js&"
export * from "./Lgx243816597420835671.vue?vue&type=script&lang=js&"
import style0 from "./Lgx243816597420835671.vue?vue&type=style&index=0&id=bbefff08&prod&scoped=true&lang=css&"
import style1 from "./Lgx243816597420835671.vue?vue&type=style&index=1&id=bbefff08&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbefff08",
  null
  
)

export default component.exports